<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Produk',

    metaInfo: { title: 'Produk' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'products',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'product',
      },
    },
  }
</script>
